<template>
  <div class="search-css">
    <SearchInput @submit="onSubmit">
      <div v-if="getSearchedKeyword" :class="getSearchInputPosition" class="search-type-wrapper">
        <SearchType :type-list="typeList" :current-type="currentType" @update="updateSearchType" />
      </div>
      <a :class="getSearchInputPosition" class="cancel" @click="closeModal">
        <i class="icon material-icons">
          close
        </i>
      </a>
    </SearchInput>
    <div ref="results" class="search-results">
      <TransitionGroup name="fade" mode="in-out" tag="div">
        <div v-if="getSearchedKeyword" key="success">
          <div class="pgnnp-container">
            <Paganiniplus />
          </div>
          <div v-if="currentType === 'all' || currentType === 'work'" key="search-result-work">
            <SearchInfo :type-name="'COMMON.WORK'" :type-key="'work'" @update="updateSearchType" />
            <SearchResultsWork />
          </div>
          <div v-if="currentType === 'all' || currentType === 'article'" key="search-result-article">
            <SearchInfo :type-name="'COMMON.BLOG'" :type-key="'article'" @update="updateSearchType" />
            <SearchResultsArticle />
          </div>
          <div v-if="currentType === 'all' || currentType === 'periodical_article'" key="search-result-periodical">
            <SearchInfo :type-name="'COMMON.PERIODICAL_ARTICLE'" :type-key="'periodical_article'" />
            <SearchResultsPeriodicalArticle />
          </div>
          <div v-if="currentType === 'all' || currentType === 'concert'" key="search-result-event">
            <SearchInfo :type-name="'COMMON.EVENT'" :type-key="'concert'" @update="updateSearchType" />
            <SearchResultsEvent />
          </div>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchInput from '@/components/search/SearchInput'
import SearchInfo from '@/components/search/SearchInfo'
import SearchType from '@/components/search/SearchType'
import SearchResultsArticle from '@/components/search/SearchResultsArticle'
import SearchResultsPeriodicalArticle from '@/components/search/SearchResultsPeriodicalArticle'
import SearchResultsWork from '@/components/search/SearchResultsWork'
// import SearchResultsPeople from '@/components/search/SearchResultsPeople'
import SearchResultsEvent from '@/components/search/SearchResultsEvent'
import LoggerService from '@/assets/services/LoggerService'
import Paganiniplus from '@/components/tsp/Paganiniplus'

const TYPE_LIST = [
  { name: 'COMMON.WORK', type: 'work' },
  { name: 'COMMON.BLOG', type: 'article' },
  { name: 'COMMON.PERIODICAL_ARTICLE', type: 'periodical_article' },
  { name: 'COMMON.EVENT', type: 'concert' }
]
export default {
  name: 'SearchCSS',
  components: {
    Paganiniplus,
    SearchInput,
    SearchInfo,
    SearchType,
    // SearchResultsPeople,
    SearchResultsEvent,
    SearchResultsWork,
    SearchResultsArticle,
    SearchResultsPeriodicalArticle
  },
  props: {},
  data() {
    return {
      typeList: TYPE_LIST,
      keyword: '',
      scope: 'css_v2',
      currentType: 'all' // all, article, event, work
    }
  },
  computed: {
    ...mapGetters(['getSearchType', 'getSearchStatus', 'getSearchResults', 'getSearchInputPosition', 'getSearchedKeyword']),
    profile() {
      return this.$store.getters.getProfile
    }
  },
  watch: {},
  created() {
    if (this.$route.query.type) {
      const queryType = this.$route.query.type
      const matchType = this.typeList.find(typeObj => queryType === typeObj.type)
      if (matchType) {
        this.currentType = matchType.type
      }
    }
    this.keyword = this.getSearchedKeyword ? this.getSearchedKeyword : ''
  },
  mounted() {},
  updated() {},
  methods: {
    closeModal() {
      this.$router.go(-1)
    },
    onSubmit(keyword) {
      if (keyword) {
        this.keyword = keyword
        const params = {
          keyword: this.keyword,
          scope: this.scope,
          type: this.currentType,
          page: 1
        }
        //
        params.lang = this.$i18n.locale.toLowerCase()

        this.$store.dispatch('KEYWORD_ON_SUBMIT', params)
        this.$router.replace({ query: { q: this.keyword, type: this.currentType } })
        //
        this.logRecord()
      }
    },
    logRecord() {
      const params = {
        userId: this.$store.getters.getProfile.id || '',
        peopleCookieId: window.localStorage.getItem('fingerprint') || '',
        refer: document.referrer || this.$route.query.refer || '',
        keyword: this.keyword,
        clickUrl: '',
        agent: window.navigator.userAgent
      }
      LoggerService.logUserSearchAction(params)

      this.$store.dispatch('GTAG_EVENT', {
        action: 'search',
        data: { 'search_term': this.keyword }
      })
    },
    updateSearchType(newType) {
      this.currentType = newType
      this.onSubmit(this.keyword)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@keyframes delay-move {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.search-type-wrapper {
  opacity: 0; // for animation init
  &:not(.fixed) {
    display: block;
    animation: delay-move 0.4s ease-in-out 0.4s 1 forwards;
  }
  &.fixed {
    display: inline-block;
    animation: delay-move 0.4s ease-in-out 0.4s 1 forwards;
  }
}
.search-css {
  margin-bottom: 120px;
}
.pgnnp-container {
  margin: 24px auto 0;
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}

@media only screen and (max-width: 368.98px) {
  .pgnnp-container {
    margin: 24px -24px;
  }
}
</style>
